<script setup lang="ts">
import { useElementBounding } from "@vueuse/core";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import { useTemplateRef } from "vue";

import { useTypedIntl } from "@/locales/typed-intl";

import Skeleton from "primevue/skeleton";

interface IProps {
  isLoading?: boolean;
  options?: Highcharts.Options;
  hasNoData?: boolean;
}

const props = defineProps<IProps>();

const { t, k } = useTypedIntl();

const noDataMessageContainer = useTemplateRef("noDataMessageContainer");
const { height: noDataMessageContainerHeight, width: noDataMessageContainerWidth } =
  useElementBounding(noDataMessageContainer);
const chartContainer = useTemplateRef("chartContainer");
const { height: chartContainerHeight, width: chartContainerWidth } = useElementBounding(chartContainer);
</script>

<template>
  <Skeleton
    v-if="props.isLoading || !props.options"
    class="!h-full min-h-[25rem]"
  />
  <div
    v-else
    ref="chartContainer"
    class="relative"
  >
    <div
      :class="{
        'pointer-events-none blur-[5px]': props.hasNoData,
      }"
    >
      <Chart :options="props.options" />
    </div>

    <div
      v-show="props.hasNoData"
      ref="noDataMessageContainer"
      class="border p-4 rounded-md flex flex-col gap-2 absolute w-[440px] bg-white"
      :style="{
        top: `${Math.floor(chartContainerHeight / 2 - noDataMessageContainerHeight / 2)}px`,
        left: `${Math.floor(chartContainerWidth / 2 - noDataMessageContainerWidth / 2)}px`,
      }"
    >
      <slot name="noDataMessage">
        <div class="flex justify-center">
          <h5>{{ t(k.global.noData) }}</h5>
        </div>
      </slot>
    </div>
  </div>
</template>
